import { EntityTypeDTO } from '@/modules/common/types/dto/response/entity-type-dto';
import { EntityType } from '@/modules/common/types/entity-type';

/**
 * Maps EntityTypeDTO from API to EntityType domain model
 */
export const mapEntityTypeFromDTO = (dto: EntityTypeDTO): EntityType => {
  switch (dto) {
    case EntityTypeDTO.USER:
      return EntityType.User;
    case EntityTypeDTO.PROJECT:
      return EntityType.Project;
    case EntityTypeDTO.CLIENT:
      return EntityType.Client;
    case EntityTypeDTO.INVOICE:
      return EntityType.Invoice;
    case EntityTypeDTO.ASSIGNMENT:
      return EntityType.Assignment;
    case EntityTypeDTO.WORKLOG:
      return EntityType.Worklog;
    case EntityTypeDTO.ISSUE:
      return EntityType.Issue;
    default:
      return EntityType.User;
  }
};
/**
 * Maps EntityType domain model to EntityTypeDTO for API
 */
export const mapEntityTypeToDTO = (entityType: EntityType): EntityTypeDTO => {
  switch (entityType) {
    case EntityType.User:
      return EntityTypeDTO.USER;
    case EntityType.Project:
      return EntityTypeDTO.PROJECT;
    case EntityType.Client:
      return EntityTypeDTO.CLIENT;
    case EntityType.Invoice:
      return EntityTypeDTO.INVOICE;
    case EntityType.Assignment:
      return EntityTypeDTO.ASSIGNMENT;
    case EntityType.Worklog:
      return EntityTypeDTO.WORKLOG;
    case EntityType.Issue:
      return EntityTypeDTO.ISSUE;
    default:
      return EntityTypeDTO.USER;
  }
};
